"use strict";

var BlsRVPageShopify = (function () {
  return {
    initRVItems: function () {
      if (window.location.search.indexOf("page=") == -1) {
        const rv_items = JSON.parse(
          localStorage.getItem("glozin__recently-viewed-products")
        );
        this.init(rv_items);
      } else {
        this.reinitReviews();
      }
    },

    init: function (rv_items) {
      const _this = this;
      const rv_div = document.querySelector(".rv-page-main");
      const div_no_product = rv_div.querySelector(".rv-no-product-js");
      const div_product = rv_div.querySelector(".row");
      if (rv_items === null || rv_items.length === 0) {
        if (div_no_product) {
          div_no_product.classList.remove("hidden");
        }
        if (div_product) {
          div_product.classList.add("hidden");
        }
        _this.skeletonFunction(0);
      } else {
        if (div_product) {
          div_product.classList.remove("hidden");
        }
        var query = "";
        rv_items.forEach((e, key, rv_items) => {
          if (!Object.is(rv_items.length - 1, key)) {
            query += e + "%20OR%20id:";
          } else {
            query += e;
          }
        });
        const section_id =
          document.querySelector(".rv-page-section").dataset.sectionId;
        var productAjaxURL =
          "?section_id=" +
          section_id +
          "&type=product&options[unavailable_products]=last&q=id:" +
          query;

        fetch(`${window.routes.search_url}${productAjaxURL}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = parser.parseFromString(responseText, "text/html");
            const results = document.createElement("div");
            results.classList.add("rv-results");
            const exist_results = rv_div.querySelector(".rv-results");
            if (exist_results) {
              exist_results.remove();
            }
            const er = html.querySelector(".rv-page-main > .rv-results");
            if (rv_items.length !== 0 && er) {
              rv_div.innerHTML = html.querySelector(".rv-page-main").innerHTML;
              _this.skeletonFunction(700);
            } else {
              _this.skeletonFunction(0);
              div_no_product.classList.remove("hidden");
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally((e) => {
            initLazyloadItem();
            BlsRVPageShopify.clearAll();
            BlsRVPageShopify.reinitReviews();
          });
      }
    },
    clearAll: function () {
      const rv_div = document.querySelector(".rv-page-main");
      if (rv_div) {
        if (!rv_div.querySelector(".clear-all-rvp")) return;
        rv_div
          .querySelector(".clear-all-rvp")
          .addEventListener("click", function () {
            rv_div.querySelector(".rv-results").remove();
            rv_div.querySelector(".clear-all-rvp").classList.add("hidden");
            localStorage.removeItem("glozin__recently-viewed-products");
            BlsRVPageShopify.initRVItems();
          });
      }
    },
    renderFallbackStars: function (el) {
      if (!el || el.querySelector(".bls-fallback-stars")) return;
      const avg = parseFloat(el.dataset.reviewAvg) || 0;
      const count = parseInt(el.dataset.reviewCount, 10) || 0;
      const full = Math.floor(avg);
      const hasHalf = avg - full >= 0.5;
      let stars = "";
      for (let i = 1; i <= 5; i++) {
        let fill = "#d9d9d9";
        if (i <= full) fill = "#ffb400";
        else if (i === full + 1 && hasHalf) fill = "#ffb400";
        stars +=
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="' +
          fill +
          '" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>';
      }
      el.innerHTML =
        '<span class="bls-fallback-stars inline-flex align-center gap-5" style="margin-top:0.7rem">' +
        '<span class="inline-flex align-center gap-2">' +
        stars +
        "</span>" +
        '<span class="dark-grey">(' +
        count +
        ")</span></span>";
    },
    reinitReviews: function () {
      const widgets = document.querySelectorAll(
        ".rv-page-main .AirReviews-Widget--Stars, .rv-page-section .AirReviews-Widget--Stars"
      );
      try {
        if (window.AirReviews?.initWidgets) {
          window.AirReviews.initWidgets();
        } else if (window.AirReviews?.init) {
          window.AirReviews.init();
        } else if (typeof window.initAirReviewsWidgets === "function") {
          window.initAirReviewsWidgets();
        } else if (window.AVADA?.Reviews?.init) {
          window.AVADA.Reviews.init();
        }
      } catch (e) {
        console.error(e);
      }

      // Fallback when app JS does not paint AJAX-injected widgets
      window.setTimeout(function () {
        document
          .querySelectorAll(
            ".rv-page-main .AirReviews-Widget--Stars, .rv-page-section .AirReviews-Widget--Stars"
          )
          .forEach(function (el) {
            if (!el.innerHTML.trim()) {
              BlsRVPageShopify.renderFallbackStars(el);
            }
          });
      }, 400);
    },
    skeletonFunction: function (timer) {
      window.setTimeout(function () {
        if (this.document.querySelector("skeleton-page")) {
          this.document.querySelector("skeleton-page").remove();
        }
        if (this.document.querySelector(".rv-page-section-inner")) {
          this.document
            .querySelector(".rv-page-section-inner")
            .classList.remove("hidden");
        }
      }, timer);
    },
  };
})();
BlsRVPageShopify.initRVItems();
